import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

interface RemoteZoomPulseContextValue {
  /** Incrementing key — change triggers CSS animation re-mount */
  pulseKey: number;
  /** Call when an external zoom event fires */
  triggerPulse: () => void;
}

const RemoteZoomPulseContext = createContext<
  RemoteZoomPulseContextValue | undefined
>(undefined);

export const RemoteZoomPulseProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [pulseKey, setPulseKey] = useState(0);

  const triggerPulse = useCallback(() => {
    setPulseKey((prev) => prev + 1);
  }, []);

  return (
    <RemoteZoomPulseContext.Provider value={{ pulseKey, triggerPulse }}>
      {children}
    </RemoteZoomPulseContext.Provider>
  );
};

export const useRemoteZoomPulse = () => {
  const context = useContext(RemoteZoomPulseContext);
  if (!context) {
    throw new Error(
      'useRemoteZoomPulse must be used within a RemoteZoomPulseProvider',
    );
  }
  return context;
};
